<template>
  <v-card :loading="loading" flat>
    <div class="pa-4">
      <div
        v-if="false && tabs <= 1"
        class="large-12 medium-12 small-12 filezone"
      >
        <input
          id="files"
          ref="files"
          multiple
          type="file"
          @change="handleFilesUpload()"
        />
        <p class="mt-2 text-center">
          <i class="fa fa-cloud-upload-alt text-primary fa-5x d-block"></i>
          فایل مورد نظر را اینجا بکشید ورها کنید.<br />یا برای آپلود فایل خود
          اینجا کلیک کنید.
        </p>
      </div>

      <template v-else>
        <detect-file-uploading @change="handleFilesUpload" />
        <!-- 
            <video-upload-handler
              v-model="videoFiles"
              onChange
              @fetch="reloadByUpload"
            /> -->
      </template>

      <v-container fluid>
        <v-row class="my-3">
          <v-col
            v-for="(file, key) in files"
            :key="key"
            :data-imgName="file.name"
            class="d-flex child-flex"
            cols="4"
            md="1"
          >
            <div v-if="file.type.indexOf('image') > -1">
              <v-img
                id="imagess"
                :ref="'preview' + parseInt(key)"
                :data-id="'files.' + key"
                :style="{
                  opacity:
                    loadingValue[key] > 25 ? loadingValue[key] / 100 : '0.3',
                }"
                aspect-ratio="1"
              >
                <v-icon
                  class="float-right border-secondary p-1 text-white bg-danger"
                  color="danger"
                  small
                  style="cursor: pointer; font-size: 20px"
                  @click="removeFile(key)"
                >
                  mdi-trash-can-outline
                </v-icon>
              </v-img>
              <v-progress-linear
                v-if="loadingValue[key] < 100"
                :key="key"
                :color="loadingValue[key] === 100 ? 'green' : 'red'"
                :value="loadingValue[key]"
              />
            </div>

            <div v-else>
              <v-img
                id="imagess"
                :style="{
                  opacity:
                    loadingValue[key] > 25 ? loadingValue[key] / 100 : '0.3',
                }"
                :height="tabs == 3 ? 120 : null"
                aspect-ratio="1"
                :src="tabs == 3 ? 'media/music.webp' : 'media/file.svg'"
              >
                <v-icon
                  class="float-right border-secondary p-1 text-white bg-danger"
                  color="danger"
                  small
                  style="cursor: pointer; font-size: 20px"
                  @click="removeFile(key)"
                >
                  mdi-trash-can-outline
                </v-icon>
              </v-img>
              <v-progress-linear
                v-if="loadingValue[key] < 100"
                :key="key"
                :color="loadingValue[key] === 100 ? 'green' : 'red'"
                :value="loadingValue[key]"
              />
            </div>
          </v-col>
        </v-row>
      </v-container>

      <div v-if="files.length > 0">
        <div class="form-group col-md-3">
          <template v-if="coreUser.username === 'tt1' && coreUser.id === 4">
            <div class="rowinfo">
              <v-text-field
                clear-icon="mdi-close-circle-outline"
                clearable
                label="سایز"
                class="contentinfo"
                list="sizes"
                prepend-inner-icon="mdi-image-size-select-large"
                @input="getBracket($event)"
              />
            </div>
            <datalist id="sizes">
              <option v-for="item in cats" :value="item">{{ item }}</option>
            </datalist>
          </template>

          <v-text-field
            clear-icon="mdi-close-circle-outline"
            clearable
            outlined
            label="نام دسته"
            list="groups"
            prepend-inner-icon="fa fa-pencil-alt"
            @input="getName($event)"
          />
          <datalist id="groups">
            <option v-for="item in cats" :value="item">{{ item }}</option>
          </datalist>
        </div>

        <v-btn
          v-status="'file_store'"
          :loading="loading"
          class="btn-upload"
          @click="submitFiles()"
        >
          <span class="fa fa-upload mr-2"></span>
          ثبت
        </v-btn>
      </div>

      <custom-tabs
        v-model="tabs"
        :tab-items="[
          { text: 'تصاویر', icon: 'image', value: 'photo' },
          { text: 'فایل‌ها', icon: 'file', value: 'files' },
          { text: 'ویدئو', icon: 'video', value: 'video' },
          { text: 'صدا', icon: 'voicemail', value: 'sound' },
        ]"
        grow
      >
        <template v-slot:staticItems>
          <v-tab-item class="mx-0 px-0">
            <v-container
              class="rounded mx-0 py-0 px-0"
              fluid
              style="
                background: #f8f8fa;
                max-height: 480px;
                overflow-y: scroll;
                position: relative;
              "
            >
              <v-row
                class="px-md-13 mx-auto justify-content-between"
                style="
                  position: sticky;
                  left: 0;
                  right: 0;
                  top: 0;
                  z-index: 10;
                  background-color: white;
                "
              >
                <v-col cols="5" md="4">
                  <v-checkbox
                    label="انتخاب همه"
                    @change="selectAll($event)"
                  ></v-checkbox>
                </v-col>
                <v-col cols="3" md="4">
                  <v-btn
                    v-if="selectedDl.length > 0"
                    :loading="loading"
                    class="btn-delete float-left"
                    @click="deleteAllFn"
                  >
                    <span class="fa fa-trash-alt ml-1"></span>
                    حذف
                  </v-btn>
                </v-col>
                <v-col cols="12" md="4">
                  <v-autocomplete
                    v-model="search"
                    :items="cats"
                    :loading="loading"
                    class="rounded-lg mt-md-2 mt-0"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    hide-details
                    label="جستجو"
                    outlined
                    @change="callImages"
                  />
                </v-col>
              </v-row>
              <v-row class="my-3 mt-5 pt-5 mx-0 px-0 justify-content-around">
                <v-col
                  v-for="(item, key) in img"
                  :key="item.id"
                  class="d-flex child-flex p-1 bg-white mx-md-1 mx-0 mb-2 rounded shadow-lg position-relative"
                  cols="4"
                  md="2"
                  @click="maximizeMe(item.full_path)"
                >
                  <v-img
                    :src="item.full_path"
                    aspect-ratio="1"
                    class="rounded img-thumbnail clssbg"
                  >
                    <v-checkbox
                      :key="item.full_path"
                      v-model="selectedDl"
                      :value="item.id"
                      class="m-0 p-0 col-2"
                      multiple
                      @click.stop
                    />
                    <v-icon
                      :key="item.id"
                      class="float-right border-secondary p-1 text-white bg-danger"
                      color="danger"
                      small
                      style="
                        cursor: pointer;
                        font-size: 20px;
                        margin-top: -15px;
                      "
                      @click.stop="removeFromGallery(item.id)"
                    >
                      mdi-trash-can-outline
                    </v-icon>
                  </v-img>
                </v-col>
              </v-row>
              <p id="dl" ref="dl"></p>
              <atom-spinner
                v-if="loading"
                :animation-duration="1500"
                :size="100"
                class="mx-auto"
                color="indigo"
              ></atom-spinner>
            </v-container>
          </v-tab-item>

          <v-tab-item>
            <v-container
              v-if="img.length > 0"
              class="rounded"
              fluid
              style="background: #f8f8fa"
            >
              <div class="d-flex px-13 justify-content-between">
                <v-checkbox
                  label="انتخاب همه"
                  @change="selectAll($event)"
                ></v-checkbox>
                <v-btn
                  v-if="selectedFile.length > 0"
                  :loading="loading"
                  class="btn-delete"
                  @click="deleteAllFn"
                >
                  <span class="fa fa-trash-alt ml-1"></span>
                  حذف
                </v-btn>
              </div>
              <v-row class="my-3 mx-0 px-0 justify-content-around">
                <v-col
                  v-for="item in misc"
                  :key="item.id"
                  class="mx-2 my-1 rounded position-relative"
                  cols="4"
                  md="2"
                >
                  <div>
                    <v-checkbox
                      v-model="selectedFile"
                      :value="item.id"
                      multiple
                    ></v-checkbox>
                    <v-img
                      v-if="item.path.split('.')[1] !== 'pdf'"
                      src="media/file.svg"
                      width="120"
                    >
                    </v-img>

                    <v-img
                      v-if="item.path.split('.')[1] === 'pdf'"
                      :src="item.full_path.replace('.pdf', '_prv.png')"
                      width="100"
                    />

                    <span class="line-clamp-1 mt-2 font-weight-bold">
                      {{ item.title }}.{{ item.path.split(".")[1] }}
                    </span>
                  </div>
                </v-col>
              </v-row>
              <p id="dl" ref="dl"></p>
            </v-container>
          </v-tab-item>

          <v-tab-item class="pa-2">
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div>
                    <v-icon color="success" right>mdi-plus</v-icon>
                    افزودن با کد آی فرم
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <video-by-link />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <v-progress-linear v-if="upLoading" height="2" />
            <v-row>
              <v-col
                v-for="(item, i) in defaultVideos.data"
                :key="i"
                cols="12"
                lg="3"
                md="4"
                sm="6"
              >
                <video-selector-card
                  :selectable="false"
                  :video="item"
                  show-delete
                />
              </v-col>

              <v-col cols="12">
                <v-card
                  v-if="
                    !loading &&
                    tabs === 2 &&
                    (!Object.hasOwn(defaultVideos, 'next_page_url') ||
                      !!defaultVideos.next_page_url)
                  "
                  v-intersect="onVideoInt"
                  class="d-flex justify-center"
                  flat
                >
                  <v-progress-circular
                    color="primary"
                    indeterminate
                    size="35"
                    width="5"
                  />
                </v-card>
              </v-col>
            </v-row>

            <v-card
              v-if="
                !loading && (!defaultVideos.data || !defaultVideos.data.length)
              "
              flat
              style="max-height: calc(90vh - 250px); overflow-y: auto"
              width="100%"
            >
              <v-card-title
                class="text-center justify-center"
                v-text="'ویدئویی پیدا نشد!'"
              />
              <v-card-subtitle class="text-center">
                برای افزودن فایل از قسمت آپلود ویدئو استفاده نمایید
              </v-card-subtitle>
            </v-card>
          </v-tab-item>

          <v-tab-item>
            <v-row v-if="audios.length > 0" :disabled="loading" class="pa-2">
              <v-col cols="12" v-if="loading">
                <atom-spinner
                  :animation-duration="1500"
                  :size="100"
                  class="mx-auto"
                  color="indigo"
                ></atom-spinner>
              </v-col>
              <v-col cols="12">
                <v-btn
                  v-if="selectedFile.length > 0"
                  :loading="loading"
                  class="btn-delete"
                  @click="deleteAllSound"
                >
                  <span class="fa fa-trash-alt ml-1"></span>
                  حذف
                </v-btn>
              </v-col>
              <v-col v-for="(audio, i) in audios" :key="i" cols="12" md="6">
                <v-card :disabled="loading">
                  <v-card-text class="d-flex">
                    <v-checkbox
                      v-model="selectedFile"
                      :value="audio.id"
                      multiple
                    ></v-checkbox>
                    <v-icon
                      @click="removeFromSound(audio.id)"
                      style="cursor: pointer"
                      color="red"
                      >mdi-trash-can</v-icon
                    >
                  </v-card-text>

                  <audio-player
                    :title="audio?.title"
                    flat
                    :file="audio.full_path"
                  />
                </v-card>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12">
                <v-card v-if="!loading" flat class="text-center">
                  <v-card-title class="text-center d-block" tag="h2"
                    >فایل صوتی پیدا نشد!</v-card-title
                  >
                  <v-card-subtitle
                    >برای افزودن فایل از قسمت آپلود فایل استفاده نمایید
                  </v-card-subtitle>
                </v-card>
                <atom-spinner
                  v-if="loading"
                  :animation-duration="1500"
                  :size="100"
                  class="mx-auto"
                  color="indigo"
                ></atom-spinner>
              </v-col>
            </v-row>
          </v-tab-item>
        </template>
      </custom-tabs>
    </div>

    <custom-popup
      v-model="showMax"
      :cons="{ title: 'نمایش عکس' }"
      close-on-confirm
    >
      <v-card>
        <image-show v-model="choosenImg" />
      </v-card>
    </custom-popup>
  </v-card>
</template>

<script>
import PicSelector from "./picSelector";
// import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import { rbAxios } from "@/main";
import { AtomSpinner } from "epic-spinners";
import ImageShow from "./imageShow.vue";
import { mapGetters } from "vuex";
import VideoUploader from "./videoUploader/videoUploader.vue";
import VideoByLink from "./videoUploader/videoByLink.vue";
import VideoSelectorCard from "./videoUploader/videoSelectorCard";
import VideoUploadHandler from "./videoUploader/videoUploadHandler";
import DetectFileUploading from "./detectFileUploading";
import AudioPlayer from "./voiceGallery/components/audioPlayer.vue";

export default {
  name: "Uploader",

  components: {
    DetectFileUploading,
    VideoUploadHandler,
    VideoSelectorCard,
    VideoByLink,
    VideoUploader,
    ImageShow,
    PicSelector,
    AtomSpinner,
    AudioPlayer,
    // TitleRibbon,
  },

  props: {
    category: {
      type: String,
    },
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "Uploader",

      bracket: null,
      loading: false,
      files: [],
      videoFiles: [],
      img: [],
      misc: [],
      cats: [],
      audios: [],
      erroredPic: 0,
      successPic: 0,
      categories: "",
      refresh: true,
      showMax: false,
      choosenImg: "",
      url: process.env.VUE_APP_ROBOT,
      tabs: 0,
      loadingValue: [],
      selectedDl: [],
      selectedFile: [],
      defaultVideos: {
        data: [],
      },
      upLoading: false,
      next_page: null,
      observer: null,
      previews: {},
      n: "",
      search: "",
      file_types: "",
    };
  },

  mounted() {
    if (this.$route.name === "uploadCenter") {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (
            entry.isIntersecting &&
            this.next_page !== null &&
            this.tabs !== 0
          ) {
            this.observer.unobserve(this.$refs.dl);
            this.getImages(this.next_page);
          }
        });
      });

      this.getImages();
      this.getFiles();
      this.getSound();
    }
  },

  computed: {
    ...mapGetters("ribbon", {
      coreUser: "user",
    }),
  },

  watch: {
    files(val) {
      val.forEach((item) => {
        this.file_types = item.type;

        if (item.type.startsWith("audio/")) {
          if (
            this.coreUser.username !== "tt1" &&
            Math.round(item.size / 1024) < 81920
          ) {
            this.$toast.success("فایل صدای شما با موفقیت خوانده شد");
            this.tabs = 3;
          } else {
            this.$toast.warning("فایل شما نمیتواند بیشتر از 80 مگابایت باشد");
          }
        } else {
          if (
            this.coreUser.username !== "tt1" &&
            Math.round(item.size / 1024) > 2048
          ) {
            this.files.splice(val.indexOf(item), 1);
            this.$toast.warning(
              "عکس های با حجم بالای 2مگابایت موردقبول نیستند."
            );
          }
        }
      });

      if (this.files.length > 20) {
        this.$toast.error("حداکثر 20 عدد عکس میتوانید انتخاب کنید.");
        this.files.splice(0, this.files.length - 20);
      } else {
        this.loadingValue.fill(0);
        this.getImagePreviews();
      }
    },
  },

  methods: {
    getImagePreviews() {
      for (let i = 0; i < this.files.length; i++) {
        if (Object.hasOwn(this.previews, this.files[i].name)) {
          this.$nextTick(() => {
            this.$refs["preview" + parseInt(i)][0].src =
              this.previews[this.files[i].name];
          });
          continue;
        }

        if (/\.(jpe?g|png|gif|svg)$/i.test(this.files[i].name)) {
          let reader = new FileReader();
          reader.addEventListener(
            "load",
            function () {
              this.$refs["preview" + parseInt(i)][0].src = reader.result;

              this.previews[this.files[i].name] = reader.result;
            }.bind(this),
            false
          );
          reader.readAsDataURL(this.files[i]);
        } else {
          this.$nextTick(function () {
            this.$refs["preview" + parseInt(i)][0].src = "/img/generic.png";
          });
        }
      }
    },
    getVideos(getDef = false) {
      this.upLoading = true;
      this.$api
        .get(
          `/user/aparat?${getDef ? "default=1&" : ""}page=${
            (this.defaultVideos.current_page || 0) + 1
          }`
        )
        .then(({ data }) => {
          let lastImg = this.defaultVideos?.data || [];
          let temp = data.data;
          temp.data = lastImg.concat(temp.data);
          this.defaultVideos = temp;
        })
        .catch(({ response }) =>
          console.log("error in get default videos: ", response)
        )
        .finally(() => (this.upLoading = false));
    },
    handleFilesUpload(e) {
      this.files = [];
      this.videoFiles = [];
      console.log("sound", e);

      if (["image", "file"].includes(e.type)) {
        this.tabs = e.type === "image" ? 0 : 1;
        // const uploadedFiles = this.$refs.files.files;
        if (e.files instanceof Array)
          for (let i = 0; i < e.files.length; i++) {
            this.files.push(e.files[i]);
          }
        else this.files.push(e.files);

        this.$nextTick(() => {
          this.getImagePreviews();
        });
      } else {
        this.tabs = 2;
        this.videoFiles = e.files;
      }
    },
    removeFile(key) {
      this.files.splice(key, 1);
      this.getImagePreviews();
    },
    getImages() {
      this.loading = true;
      let Token = "Bearer " + localStorage.getItem("id_token");

      $.ajax({
        url: `${this.url}/files`,
        fn: this.getImages,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
        },
        data: {
          file_type: "image",
          paginate: 1,
          dir: "desc",
          page: this.next_page,
          category:
            this.search === "" || this.search === null
              ? undefined
              : this.search,
        },
        type: "GET",
        success: (data) => {
          this.cats = data.data.categories;
          if (data.data.items.next_page_url) {
            this.observer.observe(this.$refs.dl);
            this.next_page = data.data.items.current_page + 1;
          } else this.next_page = null;

          this.img = [...this.img, ...data.data.items.data];

          this.loading = false;
        },
      });
    },
    getSound() {
      const vm = this;
      this.loading = true;
      let Token = "Bearer " + localStorage.getItem("id_token");

      $.ajax({
        url: `${this.url}/files`,
        fn: this.getImages,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
        },
        data: {
          file_type: "audio",
          paginate: 1,
          dir: "desc",
          page: this.next_page,
          // category:
          //   this.search === "" || this.search === null
          //     ? undefined
          //     : this.search,
        },
        type: "GET",
        success: (data) => {
          // this.cats = data.data.categories;
          // if (data.data.items.next_page_url) {
          //   this.observer.observe(this.$refs.dl);
          //   this.next_page = data.data.items.current_page + 1;
          // } else this.next_page = null;

          // this.img = [...this.img, ...data.data.items.data];
          vm.audios = data.data.items.data;
          console.log(data.data.items.data);

          this.loading = false;
        },
      });
    },
    getFiles() {
      let Token = "Bearer " + localStorage.getItem("id_token");

      $.ajax({
        url: `${this.url}/files`,
        fn: this.getImages,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
        },
        data: {
          file_type: "file",
        },
        type: "GET",
        success: (data) => {
          this.misc = data.data;
        },
      });
    },
    removeFromGallery: function (key) {
      let Token = "Bearer " + localStorage.getItem("id_token");
      this.loading = true;
      const vm = this;
      $.ajax({
        url: `${this.url}/files/${key}`,
        method: "DELETE",
        fn: this.removeFromGallery,
        params: [key],
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
        },
        msg: true,
        success: function (res) {
          vm.img = [];
          setTimeout(() => {
            vm.next_page = 1;
            vm.img = [];
            this.loading = false;

            vm.getImages();
          }, 4000);
        },
      });
    },
    // remove sound single
    removeFromSound: function (key) {
      let Token = "Bearer " + localStorage.getItem("id_token");
      this.loading = true;
      const vm = this;
      $.ajax({
        url: `${this.url}/files/${key}`,
        method: "DELETE",
        fn: this.removeFromSound,
        params: [key],
        headers: {
          ACCEPT: "application/json",
          Authorization: Token,
        },
        msg: true,
        success: function (res) {
          vm.$toast.success("فایل صوتی شما با موفقیت حذف شد");
          vm.audios = [];
          setTimeout(() => {
            vm.next_page = 1;
            vm.audios = [];
            vm.getSound();
          }, 4000);
        },
      });
    },
    // remove group
    deleteAllSound() {
      this.loading = true;
      rbAxios
        .delete("/files/mass/delete", {
          params: {
            ids:
              this.selectedDl.length > 0 ? this.selectedDl : this.selectedFile,
          },
        })
        .then((res) => {
          this.loading = false;
          this.$toast.success("فایل های صوتی  موردنطر با موفقیت حذف شدند.");
          this.next_page = 1;
          this.audios = [];
          this.selectedDl = [];
          this.getSound();
        })
        .catch(() => {
          this.loading = false;
          this.$toast.error("حذف آیتم های موردنظر شما با خطا مواجه شد.");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submitFiles(item = 0) {
      this.loading = true;

      let file_type = "";
      if (this.tabs == 0) {
        file_type = "image";
      } else if (this.tabs == 1) {
        file_type = "file";
      } else if (this.tabs == 3) {
        file_type = "audio";
      }

      console.log("file_type", file_type);

      if (this.n === "") {
        this.$toast.error("نام دسته خودرا وارد کنید.");
        this.loading = false;
        this.getImagePreviews();
      } else {
        let formData = new FormData();
        if (this.coreUser.username === "tt1" && this.coreUser.id === 4) {
          formData.append("bracket", this.bracket ?? undefined);
        }
        formData.append("category", this.n);
        formData.append("file", this.files[item]);
        formData.append("type", "other");
        formData.append("file_type", file_type);
        const Token = localStorage.getItem("id_token");

        $.ajax({
          url: `${this.url}/files`,
          fn: this.submitFiles,
          params: [item],
          type: "POST",
          data: formData,
          headers: {
            Authorization: Token,
            ACCEPT: "application/json",
          },
          xhr: () => {
            let xhr = new window.XMLHttpRequest();
            xhr.upload.addEventListener(
              "progress",
              (evt) => {
                if (evt.lengthComputable) {
                  this.loadingValue[item] = (evt.loaded / evt.total) * 100;
                  this.$forceUpdate();
                  this.getImagePreviews();
                }
              },
              false
            );
            return xhr;
          },
          contentType: false,
          processData: false,
          msg: this.files.length <= item + 1 && this.erroredPic === 0,
          reload: this,
        }).always((data) => {
          try {
            document
              .querySelectorAll("#imagess")
              [item].classList.add(
                data.status === true ? " " : "border-danger"
              );
            this.erroredPic += 1;
          } catch (e) {
            // this.getImages();
          }

          item++;
          data.status === true ? this.successPic++ : this.erroredPic++;

          if (this.files.length > item) this.submitFiles(item);
          else {
            if (this.erroredPic <= 0) {
              setTimeout(() => {
                this.files = [];
                this.categories = "";
                this.next_page = 1;
                this.img = [];
                this.getImages();
                this.getFiles();
                this.getSound();

                this.loading = false;
              }, 7000);
            } else {
              this.$nextTick(function () {
                this.$modal.error(
                  "خطا!",
                  "لظفا عکس های مشخص شده با کادر قرمز را حذف و با عکس درست جایگزین کنید و دوباره ثبت کنید."
                );
                this.loading = false;
              });
              this.erroredPic = 0;
            }
          }
        });
      }
    },
    onVideoInt(entries, observer) {
      if (
        (entries[0].isIntersecting || !this.defaultVideos.data.length) &&
        (!Object.hasOwn(this.defaultVideos, "next_page_url") ||
          !!this.defaultVideos.next_page_url)
      )
        if (this.ribbon_can("upload_video_store")) this.getVideos(true);
        else this.getVideos();
    },
    selectAll(e) {
      if (!e) {
        this.selectedDl = [];
      } else {
        this.img.forEach((item) => {
          this.selectedDl.push(item.id);
        });
      }
    },
    deleteAllFn() {
      this.loading = true;
      rbAxios
        .delete("/files/mass/delete", {
          params: {
            ids:
              this.selectedDl.length > 0 ? this.selectedDl : this.selectedFile,
          },
        })
        .then((res) => {
          this.loading = false;
          this.$toast.success("عکس های موردنطر با موفقیت حذف شدند.");
          this.next_page = 1;
          this.img = [];
          this.selectedDl = [];
          this.getImages();
        })
        .catch(() => {
          this.loading = false;
          this.$toast.error("حذف آیتم های موردنظر شما با خطا مواجه شد.");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    selectFile(e) {
      if (!e) {
        this.selectedFile = [];
      } else {
        this.misc.forEach((item) => {
          this.selectedFile.push(item.id);
        });
      }
    },
    getName(e) {
      this.n = e;
    },
    getBracket(e) {
      this.bracket = e;
    },
    maximizeMe(image) {
      this.showMax = true;
      this.choosenImg = image;
    },
    callImages() {
      this.next_page = null;
      this.img = [];
      this.getImages();
    },
    reloadByUpload() {
      this.defaultVideos = {
        data: [],
      };
    },
  },
};
</script>

<style>
.clssbg .v-input__slot {
  background-color: white !important;
}

.v-tab--active {
  border-bottom: 2px solid var(--v-primary-base);
}

.fa-pencil-alt {
  font-size: 12pt !important;
}

.border-danger {
  border: 2px solid #f44336 !important;
}

input[type="file"] {
  opacity: 0;
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.filezone {
  outline: 3px dashed #163cd0;
  outline-offset: -3px;
  color: dimgray;
  padding: 10px;
  min-height: 200px;
  position: relative;
  cursor: pointer;
  border-radius: 10px;
  background-color: #ddddeee0;
}

.filezone:hover {
  background: #ddddeee0;
}

.filezone p {
  font-size: 1.2em;
}

div.remove-container a {
  color: red;
  cursor: pointer;
}

.icon-cloud-up {
  color: #163cd0;
}

.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.line-clamp-1:hover {
  -webkit-line-clamp: 3;
}
</style>
